import { Action } from '@ngrx/store'
import * as ContactTypesTypes from './contact-types.types'
import { ContactType } from './contact-types.interface'

export class FetchContactTypesRequest implements Action {
  readonly type = ContactTypesTypes.FETCH_CONTACT_TYPES_REQUEST
  constructor(public payload: any = {}) {}
}

export class FetchContactTypesSuccess implements Action {
  readonly type = ContactTypesTypes.FETCH_CONTACT_TYPES_SUCCESS
  constructor(
    public payload: ContactType[],
    public total: number,
    public results: number,
  ) {}
}

export class FetchContactTypesFailure implements Action {
  readonly type = ContactTypesTypes.FETCH_CONTACT_TYPES_FAILURE
  constructor(public payload: any) {}
}

export class FetchContactTypeRequest implements Action {
  readonly type = ContactTypesTypes.FETCH_CONTACT_TYPE_REQUEST
  constructor(public id: number) {}
}

export class FetchContactTypeSuccess implements Action {
  readonly type = ContactTypesTypes.FETCH_CONTACT_TYPE_SUCCESS
  constructor(public payload: ContactType) {}
}

export class FetchContactTypeFailure implements Action {
  readonly type = ContactTypesTypes.FETCH_CONTACT_TYPE_FAILURE
  constructor(public payload: any) {}
}

export class DeleteContactTypeRequest implements Action {
  readonly type = ContactTypesTypes.DELETE_CONTACT_TYPE_REQUEST
  constructor(public id: number) {}
}

export class DeleteContactTypeSuccess implements Action {
  readonly type = ContactTypesTypes.DELETE_CONTACT_TYPE_SUCCESS
  constructor() {}
}

export class DeleteContactTypeFailure implements Action {
  readonly type = ContactTypesTypes.DELETE_CONTACT_TYPE_FAILURE
  constructor(public payload: any) {}
}

export class CreateContactTypeRequest implements Action {
  readonly type = ContactTypesTypes.CREATE_CONTACT_TYPE_REQUEST
  constructor(public payload) {}
}

export class CreateContactTypeSuccess implements Action {
  readonly type = ContactTypesTypes.CREATE_CONTACT_TYPE_SUCCESS
  constructor() {}
}

export class CreateContactTypeFailure implements Action {
  readonly type = ContactTypesTypes.CREATE_CONTACT_TYPE_FAILURE
  constructor(public payload: any) {}
}

export class UpdateContactTypeRequest implements Action {
  readonly type = ContactTypesTypes.UPDATE_CONTACT_TYPE_REQUEST
  constructor(public id: number, public payload) {}
}

export class UpdateContactTypeSuccess implements Action {
  readonly type = ContactTypesTypes.UPDATE_CONTACT_TYPE_SUCCESS
  constructor() {}
}

export class UpdateContactTypeFailure implements Action {
  readonly type = ContactTypesTypes.UPDATE_CONTACT_TYPE_FAILURE
  constructor(public payload: any) {}
}

export class UpdateField implements Action {
  readonly type = ContactTypesTypes.UPDATE_FIELD
  public constructor(
    public field: string,
    public value: any,
    public path: string,
  ) {}
}

export class SetDefaultData implements Action {
  readonly type = ContactTypesTypes.SET_DEFAULT_DATA
  public constructor(public path: string) {}
}

export type Actions =
  | UpdateContactTypeRequest
  | UpdateContactTypeSuccess
  | UpdateContactTypeFailure
  | FetchContactTypesSuccess
  | FetchContactTypesFailure
  | FetchContactTypesRequest
  | FetchContactTypeSuccess
  | FetchContactTypeFailure
  | FetchContactTypeRequest
  | CreateContactTypeRequest
  | CreateContactTypeSuccess
  | CreateContactTypeFailure
  | DeleteContactTypeRequest
  | DeleteContactTypeSuccess
  | DeleteContactTypeFailure
  | SetDefaultData
  | UpdateField
  | FetchContactTypesRequest
  | FetchContactTypesSuccess
  | FetchContactTypesFailure
